/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.3335 3.03947C9.69294 2.37412 11.2253 2 12.8463 2C18.4541 2 23.0002 6.47715 23.0002 12C23.0002 13.5965 22.6203 15.1056 21.9447 16.4444M20.0002 1L23.0002 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M23 22L20.026 19.0711M1 3.66667L2.69231 2L5.6663 4.92893M20.026 19.0711C18.1885 20.8807 15.6501 22 12.8462 22C7.23834 22 2.69231 17.5228 2.69231 12C2.69231 9.23858 3.82882 6.73858 5.6663 4.92893M20.026 19.0711L5.6663 4.92893"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2.69238 11.9998C2.69238 17.5226 7.23841 21.9998 12.8462 21.9998C15.6501 21.9998 18.1886 20.8805 20.0261 19.0708L5.66638 4.92871C3.82889 6.73836 2.69238 9.23835 2.69238 11.9998Z"
				fill="currentColor"
			/>
			<path
				d="M1 3.66667L2.69231 2L5.6663 4.92893M8.33333 3.03947C9.69277 2.37412 11.2251 2 12.8462 2C18.454 2 23 6.47715 23 12C23 13.5965 22.6201 15.1056 21.9445 16.4444M20.026 19.0711C18.1885 20.8807 15.6501 22 12.8462 22C7.23834 22 2.69231 17.5228 2.69231 12C2.69231 9.23858 3.82882 6.73858 5.6663 4.92893M20.026 19.0711L23 22M20.026 19.0711L5.6663 4.92893M20 1L23 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.5303 0.46967C20.2374 0.176777 19.7626 0.176777 19.4697 0.46967C19.1768 0.762563 19.1768 1.23744 19.4697 1.53033L22.4697 4.53033C22.7626 4.82322 23.2374 4.82322 23.5303 4.53033C23.8232 4.23744 23.8232 3.76256 23.5303 3.46967L20.5303 0.46967ZM3.21857 1.46564C2.92664 1.17812 2.45798 1.17812 2.16604 1.46564L0.473734 3.1323C0.178613 3.42295 0.174988 3.89781 0.465637 4.19293C0.756286 4.48805 1.23115 4.49168 1.52627 4.20103L2.69231 3.05266L4.61645 4.94765C2.95234 6.83377 1.94231 9.3004 1.94231 12C1.94231 17.9478 6.83496 22.75 12.8462 22.75C15.5857 22.75 18.0918 21.753 20.0081 20.1061L22.4737 22.5344C22.7689 22.825 23.2437 22.8214 23.5344 22.5263C23.825 22.2311 23.8214 21.7563 23.5263 21.4656L20.5523 18.5367L6.19257 4.39457L3.21857 1.46564ZM8.66303 3.71311C9.9218 3.09703 11.3416 2.75 12.8462 2.75C18.0506 2.75 22.25 6.90212 22.25 12C22.25 13.4762 21.899 14.8698 21.275 16.1066C21.0884 16.4764 21.2369 16.9274 21.6067 17.114C21.9765 17.3006 22.4275 17.1521 22.6141 16.7823C23.3412 15.3414 23.75 13.7168 23.75 12C23.75 6.05218 18.8573 1.25 12.8462 1.25C11.1086 1.25 9.46375 1.6512 8.00363 2.36582C7.63159 2.54791 7.4776 2.99712 7.65969 3.36917C7.84178 3.74121 8.29099 3.8952 8.66303 3.71311Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M1 3.66667L2.69231 2L5.6663 4.92893M8.33333 3.03947C9.69277 2.37412 11.2251 2 12.8462 2C18.454 2 23 6.47715 23 12C23 13.5965 22.6201 15.1056 21.9445 16.4444M20.026 19.0711C18.1885 20.8807 15.6501 22 12.8462 22C10.0057 22 7.4377 20.8514 5.59485 19M20.026 19.0711L23 22M20.026 19.0711L5.6663 4.92893M5.6663 4.92893C3.82882 6.73858 2.69231 9.23858 2.69231 12C2.69231 12.6849 2.76223 13.3538 2.89542 14M20 1L23 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M1 3.66667L2.69231 2L5.6663 4.92893M8.33333 3.03947C9.69277 2.37412 11.2251 2 12.8462 2C18.454 2 23 6.47715 23 12C23 13.5965 22.6201 15.1056 21.9445 16.4444M20.026 19.0711C18.1885 20.8807 15.6501 22 12.8462 22C7.23834 22 2.69231 17.5228 2.69231 12C2.69231 9.23858 3.82882 6.73858 5.6663 4.92893M20.026 19.0711L23 22M20.026 19.0711L5.6663 4.92893M20 1L23 4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.66638 3.87646L5.14011 4.39476C3.16662 6.33834 1.94238 9.02807 1.94238 12.0002C1.94238 17.948 6.83504 22.7502 12.8462 22.7502C15.8533 22.7502 18.5791 21.549 20.5523 19.6056L21.0949 19.0713L5.66638 3.87646Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.4698 0.46967C19.7627 0.176777 20.2376 0.176777 20.5305 0.46967L23.5305 3.46967C23.8234 3.76256 23.8234 4.23744 23.5305 4.53033C23.2376 4.82322 22.7627 4.82322 22.4698 4.53033L19.4698 1.53033C19.1769 1.23744 19.1769 0.762563 19.4698 0.46967ZM2.16604 1.46564C2.45798 1.17812 2.92663 1.17812 3.21857 1.46564L23.5263 21.4656C23.8214 21.7563 23.825 22.2311 23.5344 22.5263C23.2437 22.8214 22.7689 22.825 22.4737 22.5344L2.69231 3.05266L1.52627 4.20103C1.23115 4.49168 0.756286 4.48805 0.465637 4.19293C0.174988 3.89781 0.178613 3.42295 0.473734 3.1323L2.16604 1.46564ZM12.8463 2.75C11.3417 2.75 9.92197 3.09703 8.6632 3.71311C8.29115 3.8952 7.84194 3.74121 7.65985 3.36917C7.47776 2.99712 7.63175 2.54791 8.0038 2.36582C9.46391 1.6512 11.1088 1.25 12.8463 1.25C18.8575 1.25 23.7502 6.05218 23.7502 12C23.7502 13.7168 23.3414 15.3414 22.6143 16.7823C22.4277 17.1521 21.9766 17.3006 21.6068 17.114C21.237 16.9274 21.0885 16.4764 21.2751 16.1066C21.8992 14.8698 22.2502 13.4762 22.2502 12C22.2502 6.90212 18.0508 2.75 12.8463 2.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
